(function ($) {
    var cfg = window.hcpResetPassword || {};
    var s = cfg.strings || {};
    var ajaxUrl = cfg.ajaxUrl || '';

    // ── Request reset link form ──────────────────────────────────────────────

    $('#hcp-reset-form').on('submit', function (e) {
        e.preventDefault();

        var $form = $(this);
        var $btn = $('#reset-submit-btn');
        var $errorDiv = $('#reset-error-message');
        var $errorText = $('#reset-error-text');

        $errorDiv.addClass('hidden');
        $btn.prop('disabled', true).text(s.sending || '');

        var tokenPromise = window.hcpRecaptcha
            ? window.hcpRecaptcha.getToken('reset_password')
            : Promise.resolve('');

        tokenPromise.then(function (token) {
            $.ajax({
                url: ajaxUrl,
                method: 'POST',
                dataType: 'json',
                data: {
                    action: 'hcp_reset_password',
                    user_login: $form.find('[name="user_login"]').val(),
                    recaptcha_token: token,
                },
            }).done(function (data) {
                if (data.success) {
                    window.location.href = cfg.resetSuccessUrl || '/';
                } else {
                    $errorText.html(data.data.message || s.resetFailed || '');
                    $errorDiv.removeClass('hidden');
                }
            }).fail(function () {
                $errorText.html(s.error || '');
                $errorDiv.removeClass('hidden');
            }).always(function () {
                $btn.prop('disabled', false).text(s.send || '');
            });
        });
    });

    // ── New password form ────────────────────────────────────────────────────

    $('#hcp-new-password-form').on('submit', function (e) {
        e.preventDefault();

        var $form = $(this);
        var $btn = $('#new-password-submit-btn');
        var $errorDiv = $('#new-password-error');
        var $errorText = $('#new-password-error-text');
        var password = $form.find('[name="password"]').val();
        var passwordConfirm = $form.find('[name="password_confirm"]').val();

        $errorDiv.addClass('hidden');

        if (password !== passwordConfirm) {
            $errorText.html(s.passwordsNoMatch || '');
            $errorDiv.removeClass('hidden');
            return;
        }

        $btn.prop('disabled', true).text(s.resetting || '');

        var tokenPromise = window.hcpRecaptcha
            ? window.hcpRecaptcha.getToken('new_password')
            : Promise.resolve('');

        tokenPromise.then(function (token) {
            $.ajax({
                url: ajaxUrl,
                method: 'POST',
                dataType: 'json',
                data: {
                    action: 'hcp_save_new_password',
                    key: $form.find('[name="key"]').val(),
                    login: $form.find('[name="login"]').val(),
                    password: password,
                    recaptcha_token: token,
                },
            }).done(function (data) {
                if (data.success) {
                    window.location.href = cfg.loginUrl || '/';
                } else {
                    $errorText.html(data.data.message || s.resetPasswordFailed || '');
                    $errorDiv.removeClass('hidden');
                }
            }).fail(function () {
                $errorText.html(s.error || '');
                $errorDiv.removeClass('hidden');
            }).always(function () {
                $btn.prop('disabled', false).text(s.resetPassword || '');
            });
        });
    });

    // ── Password strength indicator (new password form) ──────────────────────

    var strengthLevels = [
        { label: s.strengthNone,       color: '#ef4444', width: 0,   cls: 'text-grey-03'   },
        { label: s.strengthWeak,       color: '#ef4444', width: 33,  cls: 'text-red-600'   },
        { label: s.strengthStrong,     color: '#f59e0b', width: 66,  cls: 'text-amber-600' },
        { label: s.strengthVeryStrong, color: '#10b981', width: 100, cls: 'text-green-600' },
    ];

    $('#password').on('input', function () {
        var pwd = $(this).val();
        var hasLength  = pwd.length >= 8;
        var hasUpper   = /[A-Z]/.test(pwd);
        var hasLower   = /[a-z]/.test(pwd);
        var hasNumber  = /[0-9]/.test(pwd);
        var hasSpecial = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(pwd);
        var count = [hasLength, hasUpper, hasLower, hasNumber, hasSpecial].filter(Boolean).length;

        var level = 0;
        if (pwd.length > 0) {
            if (count <= 2)                      level = 1;
            else if (count === 3 || count === 4) level = 2;
            else                                 level = 3;
        }

        var criteria = [hasLength, hasUpper, hasLower, hasNumber, hasSpecial];
        $('#password-requirements-list li').each(function (i) {
            $(this).find('span').toggleClass('bg-green-400', criteria[i]).toggleClass('bg-red-400', !criteria[i]);
        });

        var lv = strengthLevels[level];
        $('#password-strength-bar').css({ backgroundColor: lv.color, width: lv.width + '%' });
        $('#password-strength-text')
            .text(lv.label || '')
            .attr('class', 'text-xs font-medium text-grey-03 min-w-20 ' + lv.cls);
    });
}(jQuery));
